module.exports = __webpack_public_path__ + "img/logo_nhf.53c5998c.svg";